/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Button, Grid, SvgIcon } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'

interface Props {
  phone_number: string
  onRequestChange(): any
  disabled?: boolean
}
function PhonePreview(props: Props) {
  const { phone_number, onRequestChange, disabled } = props

  return (
    <Grid
      container
      justifyContent={'center'}
      css={css`
        margin-top: 20px;
        margin-bottom: 10px;

        @media (min-width: 600px) {
          padding-right: 0;
        }
      `}
    >
      <div>
        <Grid container alignItems={'center'}>
          <Grid
            item
            xs="auto"
            css={css`
              margin-right: 15px;
            `}
          >
            <Button
              variant="contained"
              onClick={onRequestChange}
              sx={{ height: '46px', minWidth: '46px' }}
              color="secondary"
              disabled={disabled}
              endIcon={
                <SvgIcon sx={{ fontSize: '18px', position: 'absolute', left: '12px', top: '12px' }} viewBox="0 0 18 16">
                  <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
                    <path
                      d="M17 9C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7L17 9ZM0.292893 7.29289C-0.097631 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538407 6.65685 0.928931L0.292893 7.29289ZM17 7L1 7L1 9L17 9L17 7Z"
                      fill="white"
                    />
                  </svg>
                </SvgIcon>
              }
            />
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: '300px',
              border: '1px solid #D0D0D0',
              backgroundColor: '#F1F1F1',
              borderRadius: '100px',
              height: '60px',
              padding: '6px',
            }}
          >
            <Grid item xs sx={{ textAlign: 'center' }}>
              <Typography sx={{ fontWeight: 600, color: '#6A707E', fontSize: '20px' }}>{phone_number}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Grid>
  )
}

export default PhonePreview
